#@import GliveBooking.Presenters.Quantity
#@export GliveBooking.Views.Quantity

class GliveBooking.Views.Quantity extends BookingV2.Views.PartySize

  module: 'glive-booking'

  presenter: GliveBooking.Presenters.Quantity

  templateName: 'quantity'
